export function getLatestRev() {
  throw new Error('getLatestRev called on the client!');
}
